module.exports = __webpack_public_path__ + "media/packs/images/notification/price-read-02d26e1565b7ede36d47882e18ab0cac.svg";